import { FormikProps } from 'formik';
import React from 'react';
import { maskDocument } from '../../../../pages/Clientes/documentUtils';
import { useFieldError } from '../hooks/useFieldError';
import { Card, FormRow, SectionTitle } from '../styles';
import { IPaymentLinkFormValues } from '../types/types';

interface IdentificationSectionProps {
  form: FormikProps<IPaymentLinkFormValues>;
}

export const IdentificationSection: React.FC<IdentificationSectionProps> = ({
  form,
}) => {
  const hasError = useFieldError(form);

  const showEmailError = hasError('email');
  const showDocumentError = hasError('document');

  return (
    <Card>
      <SectionTitle>Identificação</SectionTitle>

      <FormRow className="two-columns">
        <div className="form-group">
          <label htmlFor="payment-email">
            E-mail <span className="text-danger">*</span>
          </label>

          <input
            id="payment-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="nome@escritorio.com.br"
            className={showEmailError ? 'is-invalid' : undefined}
            aria-invalid={showEmailError}
            aria-describedby={
              showEmailError ? 'payment-email-error' : undefined
            }
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            value={form.values.email}
          />

          {showEmailError && (
            <span
              id="payment-email-error"
              className="invalid-feedback"
              role="alert"
            >
              {form.errors.email}
            </span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="payment-document">
            CPF/CNPJ <span className="text-danger">*</span>
          </label>

          <input
            id="payment-document"
            name="document"
            type="text"
            inputMode="numeric"
            placeholder="000.000.000-00"
            className={showDocumentError ? 'is-invalid' : undefined}
            aria-invalid={showDocumentError}
            aria-describedby={
              showDocumentError ? 'payment-document-error' : undefined
            }
            onChange={(e) =>
              form.setFieldValue('document', maskDocument(e.target.value))
            }
            onBlur={form.handleBlur}
            value={form.values.document}
          />

          {showDocumentError && (
            <span
              id="payment-document-error"
              className="invalid-feedback"
              role="alert"
            >
              {form.errors.document}
            </span>
          )}
        </div>
      </FormRow>
    </Card>
  );
};
